"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OwnersDisplayGrid = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const NumberCellFormatter_1 = require("../datagrid/cellFormatters/NumberCellFormatter");
const UserNameCell_1 = require("../datagrid/cellFormatters/UserNameCell");
function memoizedGetColumns(metricsDataCatalogEnabled, publishedConnectionsLineageEnabled) {
    const ownedMetricsColumn = (sortParams) => ({
        name: 'ownedMetrics',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: catalog_messages_1.Messages.GridHeaderOwnedMetrics(),
        headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams, 'right'),
        cellFormatter: (0, NumberCellFormatter_1.createNumberCellFormatter)(({ metricsCount }) => metricsCount),
        resizable: true,
        sortable: false,
    });
    const ownedVirtualConnectionsColumn = (sortParams) => ({
        name: 'ownedVirtualConnections',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: catalog_messages_1.Messages.GridHeaderOwnedVirtualConnections(),
        headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams, 'right'),
        cellFormatter: (0, NumberCellFormatter_1.createNumberCellFormatter)(({ virtualConnectionsCount }) => virtualConnectionsCount),
        resizable: true,
        sortable: false,
    });
    return [
        () => (0, data_catalog_shared_1.createSelectionColumn)(),
        (sortParams) => ({
            name: 'name',
            dataKey: catalog_queries_1.TableauUserOrderField.NAME,
            headerText: catalog_messages_1.Messages.GridHeaderName(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, UserNameCell_1.createUserNameLinkCellFormatter)(user => user),
            resizable: true,
            sortable: sortParams.areUsersVisible,
        }),
        (sortParams) => ({
            name: 'ownedWorkbooks',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: catalog_messages_1.Messages.GridHeaderOwnedWorkbooks(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams, 'right'),
            cellFormatter: (0, NumberCellFormatter_1.createNumberCellFormatter)(({ workbookCount }) => workbookCount),
            resizable: true,
            sortable: false,
        }),
        (sortParams) => ({
            name: 'ownedDatasources',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: catalog_messages_1.Messages.GridHeaderOwnedDatasources(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams, 'right'),
            cellFormatter: (0, NumberCellFormatter_1.createNumberCellFormatter)(({ datasourceCount }) => datasourceCount),
            resizable: true,
            sortable: false,
        }),
        ...(metricsDataCatalogEnabled ? [ownedMetricsColumn] : []),
        ...(publishedConnectionsLineageEnabled ? [ownedVirtualConnectionsColumn] : []),
    ];
}
function OwnersDisplayGrid(props) {
    const featureFlags = (0, catalog_core_1.useFeatureFlags)();
    const { areUsersVisible } = (0, catalog_core_1.useUserSiteSettings)();
    return (react_1.default.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: memoizedGetColumns(featureFlags.metricsDataCatalogEnabled, featureFlags.publishedConnectionsLineageEnabled)
            .map(columnFactory => columnFactory(Object.assign(Object.assign({}, props), { areUsersVisible }))), rowStore: props.rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.OwnersDisplayGrid = OwnersDisplayGrid;
//# sourceMappingURL=OwnersDisplayGrid.js.map